import { render, staticRenderFns } from "./NewAssignationDialog.vue?vue&type=template&id=58265f41"
import script from "./NewAssignationDialog.vue?vue&type=script&lang=js"
export * from "./NewAssignationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports